// extracted by mini-css-extract-plugin
export default {"cartContainer":"cartContainer__wOCyh","badge":"badge__D6WlB"};